<template>
  <div>
    <a-modal
      v-model="isShow"
      centered
      :mask-closable="false"
      :ok-button-props="{ props: { loading: submitting } }"
      title="导入ProfileData"
      @ok="handleSubmit"
    >
      <a-form
        class="simiot-compact-form"
        :form="form"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 15 }"
        @submit="handleSubmit"
      >
        <a-form-item label="供应商">
          <a-select
            v-decorator="['profile_supplier_id', { rules: [{ required: true, message: '请选择供应商' }] }]"
            show-search
            option-filter-prop="children"
            :loading="loadingSupplierOptions"
          >
            <a-select-option v-for="opt in supplierOptions" :key="opt.id" :value="opt.id">
              {{ opt.name }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="导入文件" required>
          <upload-custom-file
            accept=".xls,.xlsx"
            hint="支持excel格式，20MB以内"
            :max-size="20*1024*1024"
            @change="handleUploadChange"
            v-decorator="['attachment', {
              rules: [{ validator: checkFileList }],
            }]"
          />
        </a-form-item>

        <a-form-item label="模版">
          <div>
            <a href="/static/profile_datas_import_template.xlsx" target="_blank">点击下载导入模版</a>
            <font color="red"> (IMSI、ICCID必填)</font>
          </div>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { findProfileSuppliers } from '@/api/profile_supplier'
import { importProfileDatas } from '@/api/profile_data'
import UploadCustomFile from '@/components/Upload/CustomFile'

export default {
  name: 'ImportProfileDatas',
  components: { UploadCustomFile },
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      fileList: [],
      form: this.$form.createForm(this, { name: 'import_profile_datas' }),
      submitting: false,
      supplierOptions: [],
      loadingSupplierOptions: false
    }
  },
  computed: {
    isShow: {
      get() { return this.visible },
      set(val) { this.$emit('update:visible', val) }
    }
  },
  created() {
    this.fetchSupplierOptions()
  },
  methods: {
    fetchSupplierOptions() {
      this.loadingSupplierOptions = true
      findProfileSuppliers({ page: 1, per_page: 500 }).then((res) => {
        if (res.code === 0) this.supplierOptions = res.data
        this.loadingSupplierOptions = false
      })
    },
    handleUploadChange(fileList) {
      this.fileList = fileList
    },
    checkFileList(rule, value, callback) {
      if (!this.fileList[0] || this.fileList[0].status === 'error') {
        // eslint-disable-next-line standard/no-callback-literal
        callback('请上传文件')
        return
      }
      // eslint-disable-next-line standard/no-callback-literal
      callback()
    },
    handleSubmit(e) {
      e.preventDefault()
      if (this.submitting) {
        this.$warning({ title: '请勿重复提交', content: '' })
        return
      }
      if (this.$lodash.find(this.fileList, { status: 'uploading' })) {
        this.$warning({ title: '文件尚未上传完成', content: '' })
        return
      }
      this.form.validateFields((err, values) => {
        if (err) return
        this.submitting = true
        importProfileDatas({
          profile_supplier_id: values.profile_supplier_id,
          attachment: this.fileList[0].response
        }).then((res) => {
          if (res.code === 0) {
            this.isShow = false
            this.$emit('completed')
            this.$success({
              title: '提交成功',
              content: (<div><p>操作成功，具体结果请至 【系统管理】-【批量操作】 查看</p></div>)
            })
          }
          this.submitting = false
        }).catch(() => { this.submitting = false })
      })
    }
  }
}
</script>
